module.exports = __webpack_public_path__ + "img/ispr_not1024_text.0162de27.png";